import { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import PageHeading from '~/components/page-heading';
import TextInput from '~/components/text-input';
import Select from '~/components/select';
import Button from '~/components/button';
import UploadPhoto from '~/components/upload-photo';
import useAddNewMember from '~/hooks/useAddNewMember';
import { GENDER } from './constants';

const AddMember = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [position, setPosition] = useState('');
  const [gender, setGender] = useState(null);
  const [image, setImage] = useState(null);
  const { addNewMember, loading } = useAddNewMember();

  const isValidForm = useMemo(() => {
    return !!(
      firstName &&
      lastName &&
      email &&
      phone &&
      position &&
      gender &&
      image
    );
  }, [firstName, lastName, email, phone, position, gender, image]);

  const onAddMemberClick = useCallback(() => {
    addNewMember({
      firstName,
      lastName,
      email,
      phone,
      position,
      gender,
      image,
    }).then(() => navigate('/team'));
  }, [
    addNewMember,
    navigate,
    firstName,
    lastName,
    email,
    phone,
    position,
    gender,
    image,
  ]);

  return (
    <>
      <S.TopBar>
        <PageHeading>Add Team Member</PageHeading>
      </S.TopBar>
      <S.Content>
        <UploadPhoto onImageChange={setImage} />
        <S.Grid>
          <TextInput
            placeholder="Enter your first name"
            label="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextInput
            placeholder="Enter your last name"
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <TextInput
            placeholder="Enter your email"
            label="Your Email"
            value={email}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextInput
            placeholder="Enter your phone number"
            label="Phone Number"
            value={phone}
            type="tel"
            onChange={(e) => setPhone(e.target.value)}
          />
          <TextInput
            placeholder="CEO"
            label="Position"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
          />
          <S.Select
            label="Gender"
            value={gender}
            selectedLabel={GENDER[gender]}
            onChange={setGender}
          >
            <S.Select.Option value="male">Male</S.Select.Option>
            <S.Select.Option value="female">Female</S.Select.Option>
          </S.Select>
        </S.Grid>
        <S.AddNowButton
          onClick={onAddMemberClick}
          disabled={!isValidForm || loading}
        >
          Add now
        </S.AddNowButton>
      </S.Content>
    </>
  );
};

const S = {
  TopBar: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  Content: styled.section`
    background: #fff;
    padding: 2rem;
    margin: 1rem 0;
    border-radius: 14px;
  `,
  Grid: styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 1rem;
    padding: 2rem 0;

    @media (min-width: ${({ theme }) => theme.screens.md}) {
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 1rem;
    }

    @media (min-width: ${({ theme }) => theme.screens.lg}) {
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 2rem;
      padding: 2rem 4rem;
    }
  `,
  Select: styled(Select)`
    max-width: 200px;
  `,
  AddNowButton: styled(Button)`
    max-width: 300px;
    width: 100%;
    font-size: 1.2rem;
    margin: 0 auto;
    display: block;
    padding: 1.25rem 1rem;
    border-radius: 12px;

    &:disabled {
      opacity: 0.6;
    }
  `,
};

export default AddMember;
